import { NgModule } from '@angular/core';

import { IsErrorStatePipe, IsLoadingStatePipe, IsSuccessStatePipe } from './page-state/page-state';

const pipes: any[] = [IsLoadingStatePipe, IsSuccessStatePipe, IsErrorStatePipe];

@NgModule({ declarations: pipes, exports: pipes })
export class PipesModule {}
